import { PointType } from "src/app/pages/custom-route/interfaces/custom-route.interface";
import { EditedCustomRoute, UpdateCustomEditedRouteBody } from "../interfaces/edit-route.interface";
import dayjs from "dayjs";

export const updateCustomEditedRouteBodyAdapter = (
  editedCustomRoute: EditedCustomRoute, 
  token: string,
  dayToShowIndex: number
): UpdateCustomEditedRouteBody => {
  return {
    token: token,
    date: dayjs(editedCustomRoute.dailyRoutes[dayToShowIndex].date).format('YYYY-MM-DD'), // '2023-10-01'
    points: 
      editedCustomRoute.dailyRoutes[dayToShowIndex].points.map(point => ({
          id: point.id,
          title: point.title,
          type: point.type as PointType,
          status: point.status, // Assuming status is already in the correct format
          startDate: dayjs(point.startDate).format('YYYY-MM-DDTHH:mm:ss'), // '2023-10-01T09:00:00'
        }))
  };
}